module.exports = __webpack_public_path__ + "static/media/intro_page_picture1.820e9988.png";